<svg width="120" height="121" viewBox="0 0 120 121" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M72 9.5H20V63.5H8V67.5L20 67.5H100L112 67.5V63.5H100V38L72 38V9.5ZM28 71.5H36H44V79.5H36V87.5H28V95.5H20V87.5V79.5H28V71.5ZM28 103.5V95.5H36V87.5H44V79.5H52V71.5H60H68V79.5H76V87.5H68H60H52V95.5H44V103.5H52V111.5H44H36V103.5H28ZM28 103.5V111.5H20V103.5H28ZM60 103.5H52V95.5H60V103.5ZM68 103.5H60V111.5H68V103.5ZM76 95.5H68V103.5H76V111.5H84V103.5H92V111.5H100V103.5V95.5H92V87.5H100V79.5V71.5H92H84H76V79.5H84V87.5H76V95.5ZM76 95.5H84V103.5H76V95.5ZM76 10L100 34H76V10Z"
    fill="#E8E8E8"
  />
</svg>
